module.exports = __webpack_public_path__ + "static/media/logo.f9878147.png";